import { Service, inject } from '@angular/core';
import { NgxHttpClient } from '@degreed/lxp/services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface OrgAnnouncements {
  title: string;
  description: string;
  linkName: string;
  linkUrl: string;
  imageUrl: string;
  enabled: boolean;
}

@Service()
export class OrgAnnouncementsService {
  private http = inject(NgxHttpClient);

  public getOrgAnnouncements(
    organizationId: number
  ): Observable<OrgAnnouncements> {
    // get the org setting that stores the org announcement data

    const announcement$ = this.http
      .get<any>('/organizations/GetSettings', {
        params: {
          organizationId,
          visibility: 'OrgHome',
        },
      })
      .pipe(
        map((results) => {
          let orgAnnouncementsEnabled = false;
          let orgAnnouncementLinks: Partial<OrgAnnouncements> = {};
          results?.settings?.forEach((setting: any) => {
            switch (setting.id) {
              case 'OrgAnnouncementLinks':
                orgAnnouncementLinks = JSON.parse(setting.value || '{}');
                break;
              case 'OrgAnnouncements':
                orgAnnouncementsEnabled = setting.enabled;
                break;
            }
          });
          // Always emit the full OrgAnnouncements shape — an org with no
          // OrgAnnouncementLinks setting (or a stored '{}') must not drop the
          // string fields, or Signal Forms can't materialise them downstream.
          return {
            title: orgAnnouncementLinks.title ?? '',
            description: orgAnnouncementLinks.description ?? '',
            linkName: orgAnnouncementLinks.linkName ?? '',
            linkUrl: orgAnnouncementLinks.linkUrl ?? '',
            imageUrl: orgAnnouncementLinks.imageUrl ?? '',
            enabled: orgAnnouncementsEnabled,
          };
        })
      );
    return announcement$;
  }

  public saveOrgAnnouncements(
    orgId: number,
    orgAnnouncement: OrgAnnouncements
  ) {
    const payload: Record<string, string> = {};

    (Object.keys(orgAnnouncement) as (keyof OrgAnnouncements)[]).forEach(
      (key) => {
        if (key !== 'enabled') {
          payload[key] =
            orgAnnouncement[key] === null ? '' : orgAnnouncement[key];
        }
      }
    );

    return this.http.post(
      '/organizations/UpdateOrgAnnouncement',
      {
        organizationId: `${orgId}`,
        enabled: `${orgAnnouncement.enabled ?? false}`,
        ...payload,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }
}
